import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import PageLayout from '@/components/layout/PageLayout';
import { CreateEmployeeContractForm } from '@/components/features/employee/createEmployeeContractForm';
import { useEmployeeContractCreate } from '@/hooks/employee/useEmployeeContractCreate';
import { ROUTE_DEFINITIONS } from '@/routes';
import { formatRut, toCapitalCase } from '@/utils';


export const EmployeeContractCreate: React.FC = () => {
  const { employeeId } = useParams<{ employeeId: string }>();

  const {
    isLoading,
    creating,
    employeeProfile,
    handleCancel,
    handleCreate,
    contractStatusOptions,
    contractTypeOptions,
    contractModalityOptions,
    companyOptions,
    areaOptions,
    positionOptions,
    costCenterOptions,
    unionOptions,
    form,
  } = useEmployeeContractCreate(employeeId ? Number(employeeId) : undefined);

  // Build backTo URL with employeeId query parameter
  const backToUrl = useMemo(() => {
    const baseUrl = ROUTE_DEFINITIONS.EMPLEADO_CONTRATOS.path;
    return employeeId ? `${baseUrl}?employeeId=${employeeId}` : baseUrl;
  }, [employeeId]);
  
  // Build dynamic title with employee name and RUT
  const dynamicTitle = useMemo(() => {
    if (!employeeProfile) return undefined;
    const rutFull = formatRut(employeeProfile.rutFull) || '';
    const fullName = toCapitalCase(`${employeeProfile.firstNames} ${employeeProfile.lastName} ${employeeProfile.secondLastName}`);
    return `Crear contrato - ${fullName} ${rutFull}`;
  }, [employeeProfile]);

  return (
    <PageLayout backTo={backToUrl} dynamicTitle={dynamicTitle} isLoading={isLoading}>
      <CreateEmployeeContractForm
        contractForm={form}
        contractStatusOptions={contractStatusOptions}
        contractTypeOptions={contractTypeOptions}
        contractModalityOptions={contractModalityOptions}
        companyOptions={companyOptions}
        areaOptions={areaOptions}
        positionOptions={positionOptions}
        costCenterOptions={costCenterOptions}
        unionOptions={unionOptions}
        creating={creating}
        onCancel={handleCancel}
        onSave={handleCreate}
      />
    </PageLayout>
  );
};

export default EmployeeContractCreate;
